import styled from 'styled-components'

export const ContentContainer = styled.div`
  padding: 1rem;
  background-color: #fff;
  height: calc(100% - 162px);
  overflow-y: auto;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  box-sizing: border-box;
`

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding: 1rem;
  height: 84px;
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  box-sizing: border-box;
`


export const PopupContainer = styled.div`
  padding: 1.5rem 1rem;
  border-radius: 8px;
  background: white;
`

export const PopupTitle = styled.div`
  margin-bottom: 1.75rem;
  font-size: 1.2rem;
  line-height: 1.4;
  font-weight: 600;
`

export const PopupDescription = styled.div`
  margin-bottom: 1.75rem;
  font-size: 1rem;
  line-height: 1.5;
`

export const PopupButtonsContainer = styled.div`
  margin-bottom: 1rem;
`
